
import LeaderAveragePointsChart from './LeaderboardAveragePointsChart.vue'
import LeaderAwardWinnersChart from './LeaderboardAwardWinnersChart.vue'
import { controls } from '~/mixins/carousel'

export default {
  components: { LeaderAveragePointsChart, LeaderAwardWinnersChart },
  mixins: [controls],
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      navLabels: [],
    }
  },
  watch: {
    activeDot(val) {
      const container = this.$refs.container
      const target = container?.querySelector(`[data-slide="${val}"]`)
      this.animateShape(target)
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.navLabels = this.blok.nav_btn_labels.split(',').map((x) => {
        if (!x) return []

        const label = x
        const href = x.toLowerCase().replace(' ', '-')

        return {
          href: '#' + href,
          label,
        }
      })
    })
  },
  methods: {
    animateShape(target) {
      const state = this.$Flip.getState(this.$refs.buttonShape?.[0])
      target.appendChild(this.$refs.buttonShape?.[0])

      this.$Flip.from(state, {
        absolute: true,
        duration: 0.5,
        ease: 'easeInOut',
      })
    },
  },
}
